import { createSelector } from 'reselect';
import { Map as IMap } from 'immutable';

export const getLoyalty = state => state.get('loyalty', IMap());

export const getLoyaltyNumber = createSelector(
    getLoyalty,
    loyalty => loyalty.get('loyaltyNumber', '')
);
